require("!!/Users/javier/www/AS/crm/node_modules/script-loader/addScript.js")(require("!!/Users/javier/www/AS/crm/node_modules/raw-loader/index.js!/Users/javier/www/AS/crm/node_modules/chart.js/dist/Chart.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/Chart.min.js
// module id = 438
// module chunks = 6